import React, { useEffect } from "react";
import { useMixpanel } from "@taskpane/context";
import { Header } from "@taskpane/components";
import { withTransition } from "@taskpane/hoc";
import css from "./MaintenanceScreen.module.scss";

const MaintenanceScreen: React.FC = () => {
  const { trackEvent } = useMixpanel();

  const attrs = {
    container: {
      className: css.container,
    },
    content: {
      className: css.content,
    },
    image: {
      className: css.image,
      src: "/assets/maintenance.png",
      alt: "Maintenance Time",
    },
    textWrapper: {
      className: css.textWrapper,
    },
    title: {
      className: css.title,
    },
    description: {
      className: css.description,
    },
  };

  useEffect(() => {
    trackEvent("maintenanceScreen.view");
  }, [trackEvent]);

  return (
    <div {...attrs.container}>
      <Header />
      <div {...attrs.content}>
        <img {...attrs.image} />
        <div {...attrs.textWrapper}>
          <span {...attrs.title}>Maintenance Time</span>
          <span {...attrs.description}>
            We’re currently performing scheduled maintenance to improve our services. We apologize
            for any inconvenience and expect to be back online shortly.
          </span>
        </div>
      </div>
    </div>
  );
};

export default withTransition(MaintenanceScreen);
